import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Button, Icon, Form } from 'semantic-ui-react'
import { generate as genId } from 'shortid'
import Input from './Input'
import Wysiwyg from './Wysiwyg'
import FileUrl from './FileUrl'

function CourseStep({ step, index, pos, onChange, onReorder, onRemove }) {
  return (
    <div className="course-steps-item">
      <div className="course-steps-item-fields">
        <Form.Field className="form-field">
          <label>Otsikko</label>
          <Input
            name="step-title"
            value={step.get('title', '')}
            onChange={e => {
              let { value } = e.target || e
              onChange(step.set('title', value))
            }}
          />
        </Form.Field>
        <Form.Field className="form-field">
          <label>Video</label>
          <FileUrl
            name="step-video"
            access="public"
            fileType={['video']}
            value={step.get('video', '')}
            onChange={({ value }) => onChange(step.set('video', value))}
          />
        </Form.Field>
      </div>
      <div className="course-steps-item-content">
        <Form.Field className="form-field">
          <label>Sisältö</label>
          <Wysiwyg
            name="step-content"
            value={step.get('content', '')}
            onChange={({ value }) => onChange(step.set('content', value))}
          />
        </Form.Field>
      </div>
      <div className="course-steps-item-actions">
        <button
          className="course-steps-item-action course-steps-item-action--reorder-up"
          onClick={e => e.preventDefault() & onReorder('up')}
          disabled={pos === 'first'}>
          <Icon name="chevron up" />
        </button>
        <button
          className="course-steps-item-action course-steps-item-action--remove"
          onClick={e => e.preventDefault() & onRemove()}>
          <Icon name="trash" />
        </button>
        <button
          className="course-steps-item-action course-steps-item-action--reorder-down"
          onClick={e => e.preventDefault() & onReorder('down')}
          disabled={pos === 'last'}>
          <Icon name="chevron down" />
        </button>
      </div>
    </div>
  )
}

export default class CourseSteps extends Component {
  updateValue = value => {
    let { onChange, name } = this.props
    onChange({ name, value })
  }

  getValue = () => {
    let { value } = this.props
    return List.isList(value) ? value : List()
  }

  addStep = () => {
    this.updateValue(this.getValue().push(Map({ id: genId() })))
  }

  reorder = (key, dir) => {
    let value = this.getValue()
    let step = value.get(key)

    if (dir === 'up' && key > 0) {
      value = value.remove(key).splice(key - 1, 0, step)
    } else if (dir === 'down' && key < value.size - 1) {
      console.log(dir, value.size, key)
      value = value.remove(key).splice(key + 1, 0, step)
    }

    this.updateValue(value)
  }

  render() {
    let value = this.getValue()

    return (
      <div className="course-steps">
        {value.size ? (
          <div className="course-steps-list">
            {value.map((step, key) => (
              <CourseStep
                step={step}
                index={key}
                pos={!key ? 'first' : key === value.size - 1 ? 'last' : 'default'}
                onChange={step => this.updateValue(value.set(key, step))}
                onRemove={() => this.updateValue(value.remove(key))}
                onReorder={dir => this.reorder(key, dir)}
                key={step.get('id')}
              />
            ))}
          </div>
        ) : null}
        <div className="course-steps-action">
          <Button
            color="blue"
            size="tiny"
            content="Lisää osio"
            icon="plus"
            onClick={e => e.preventDefault() & this.addStep()}
          />
        </div>
      </div>
    )
  }
}
